import { isDocumentNode } from 'anodum';
import constants from '../../constants';

const { CSS_GEMERATOR_STYLE_TAG_ID } = constants;

const getStyleTagForCSSGenerator = (documentNode, createNode = true) => {
  if (!isDocumentNode(documentNode)) {
    throw new TypeError('documentNode is not a Document');
  }

  const styleElement = documentNode.querySelector(`#${CSS_GEMERATOR_STYLE_TAG_ID}`);
  if (createNode && !styleElement) {
    const newElement = documentNode.createElement('style');
    newElement.id = CSS_GEMERATOR_STYLE_TAG_ID;
    newElement.setAttribute('type', 'text/css');

    const head = documentNode.head || documentNode.querySelector('head');
    if (!head) {
      throw new Error('Head element is not found in the document');
    }

    head.appendChild(newElement);
    return newElement;
  }

  return styleElement || null;
};

export default getStyleTagForCSSGenerator;
